import { useEffect, useState } from "react";
import { FiDownload, FiFile } from "react-icons/fi";
import { downloadConsultingMessageFile } from "../api/mintSpaceConsulting";

export default function ConsultingMessageBody({ mintSpaceId, message, isDark }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!message?.hasFile || !mintSpaceId || !message.engagementId) return undefined;
    if (message.type !== "image" && message.type !== "video" && message.type !== "audio") {
      return undefined;
    }
    let cancelled = false;
    let objectUrl = null;
    (async () => {
      try {
        setLoading(true);
        const blob = await downloadConsultingMessageFile(
          mintSpaceId,
          message.engagementId,
          message._id
        );
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      } catch {
        if (!cancelled) setBlobUrl(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [mintSpaceId, message?._id, message?.engagementId, message?.hasFile, message?.type]);

  const download = async () => {
    const blob = await downloadConsultingMessageFile(
      mintSpaceId,
      message.engagementId,
      message._id
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = message.fileName || "download";
    a.click();
    URL.revokeObjectURL(url);
  };

  if (message.type === "text" || !message.hasFile) {
    return message.text ? (
      <span className="whitespace-pre-wrap break-words">{message.text}</span>
    ) : null;
  }

  const muted = "text-label-secondary";

  if (message.type === "image") {
    return (
      <div className="space-y-1">
        {loading && <p className={`text-caption-1 ${muted}`}>Loading…</p>}
        {blobUrl ? (
          <img src={blobUrl} alt="" className="max-h-48 max-w-full rounded-radius-xs object-cover" />
        ) : null}
        {message.text ? <p className="text-subheadline">{message.text}</p> : null}
      </div>
    );
  }

  if (message.type === "video") {
    return (
      <div className="space-y-1">
        {blobUrl ? (
          <video src={blobUrl} controls className="max-h-48 max-w-full rounded-radius-xs" />
        ) : (
          <p className={`text-caption-1 ${muted}`}>{loading ? "Loading…" : "Video"}</p>
        )}
        {message.text ? <p className="text-subheadline">{message.text}</p> : null}
      </div>
    );
  }

  if (message.type === "audio") {
    return (
      <div className="space-y-1">
        {blobUrl ? <audio src={blobUrl} controls className="max-w-full" /> : null}
        {message.text ? <p className="text-subheadline">{message.text}</p> : null}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={download}
      className="flex items-center gap-2 text-left text-subheadline underline"
    >
      <FiFile className="h-4 w-4 shrink-0" />
      {message.fileName || "File"}
      <FiDownload className="h-3 w-3 opacity-70" />
    </button>
  );
}
